module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"flowPlatform":"Flow Platform","flowService":"Flowの提供サービス","iotHardware":"IoTハードウェア","party":"サードパーティ製アプリとの統合","connectSubtitle":"IoTソリューションやアプリとの連携で更に便利に","flowgo":"Flow Go"}}')
  delete Component.options._Ctor
}
